import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-videos-tutorial-portal',
  templateUrl: './videos-tutorial-portal.component.html',
  styleUrls: ['./videos-tutorial-portal.component.css']
})
export class VideosTutorialPortalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
